const KEY = 'apem:connected-show';
let cachedToken;
let cachedFingerprint;

function fingerprint(token) {
    if (cachedToken !== token) {
        cachedToken = token;
        cachedFingerprint = crypto.subtle.digest('SHA-256', new TextEncoder().encode(token))
            .then(bytes => Array.from(new Uint8Array(bytes), byte => byte.toString(16).padStart(2, '0')).join(''));
    }
    return cachedFingerprint;
}

export async function savedShowSession(token) {
    try {
        const saved = JSON.parse(localStorage.getItem(KEY));
        if (!token || !saved || !Number.isSafeInteger(saved.id) || saved.id <= 0) return null;
        return saved.session === await fingerprint(token) ? saved.id : null;
    } catch { return null; }
}

export async function rememberShowSession(token, showId, isCurrent = () => true) {
    const id = Number(showId);
    if (!token || !Number.isSafeInteger(id) || id <= 0) return;
    try {
        const session = await fingerprint(token);
        if (isCurrent() && localStorage.getItem('token') === token) localStorage.setItem(KEY, JSON.stringify({ id, session }));
    } catch { /* Storage restrictions must not prevent entering a show. */ }
}

export function forgetShowSession(showId) {
    try {
        const saved = JSON.parse(localStorage.getItem(KEY));
        if (showId === undefined || saved?.id === Number(showId)) localStorage.removeItem(KEY);
    } catch { /* A malformed or unavailable store cannot be restored. */ }
}
